import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Hallway (Phase 13A). Deliberately the smallest scope in this batch:
 * flooring, painting, trim, and lighting only - no built-ins and no
 * windows/doors category at all, since a hallway/corridor essentially
 * never involves either as renovation scope. This exclusion is itself
 * the thing that makes hallway "materially distinct" from the other nine
 * types, per the brief, rather than a generic room form with the title
 * changed.
 */
export const calculateHallway = createInteriorRoomCalculator({
  projectType: "hallway",
  anchorItemId: "hallway_base_renovation",
  tierFeatures: [
    {
      answerKey: "hallway_flooring_type",
      itemIdByTier: { not_changing: null, basic: "hallway_flooring_basic", mid_range: "hallway_flooring_mid", premium: "hallway_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "hallway_painting",
      itemIdByTier: { not_included: null, walls_only: "hallway_painting_walls", full_room: "hallway_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "hallway_trim",
      itemIdByTier: { keep_existing: null, standard_upgrade: "hallway_trim_standard", premium_millwork: "hallway_trim_premium" },
      excludedMessage: "Trim/millwork is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "hallway_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "hallway_lighting_standard", statement_lighting: "hallway_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    }
  ],
  electricalItemId: "hallway_electrical",
  demolitionItemId: "hallway_demolition",
  accessibilityItemId: "hallway_accessibility",
  permitDesignItemId: "hallway_permit_design"
});
